import React from "react";

const EnjoyYourStay = () => (
  <li className="PropertyAccess__item big-text">
    Enjoy your stay!
  </li>
);

export default EnjoyYourStay;
